// 需要使用 await
const isEpaas = () => {
    return window.jst_core.env.isEpaas()
}

// 需要使用 await
const isErp = () => {
    return window.jst_core.env.isErp()
}

// 需要使用 await
const isGyl = () => {
    return window.jst_core.env.isGyl()
}

export default {
    isEpaas,
    isErp,
    isGyl,
}
